// REST + WebSocket client.
let token = null;
try { token = localStorage.getItem('token'); } catch { /* storage unavailable */ }

export function setToken(t) {
  token = t;
  try { if (t) localStorage.setItem('token', t); else localStorage.removeItem('token'); } catch { /* ignore */ }
}
export const getToken = () => token;

export async function api(method, path, body) {
  const r = await fetch(path, {
    method,
    headers: { 'content-type': 'application/json', ...(token ? { authorization: `Bearer ${token}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await r.json(); } catch { /* empty */ }
  if (!r.ok) {
    const err = new Error((data && data.error) || `Request failed (${r.status})`);
    err.status = r.status;
    throw err;
  }
  return data;
}

// Live connection with automatic reconnect. handlers: { market, book, accounts, event, status }
export function connectLive(handlers) {
  let ws = null, closed = false, bookSymbol = null, retry = 0;
  const open = () => {
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    ws = new WebSocket(`${proto}://${location.host}/ws`);
    ws.onopen = () => {
      retry = 0;
      handlers.status && handlers.status(true);
      if (token) ws.send(JSON.stringify({ type: 'auth', token }));
      if (bookSymbol) ws.send(JSON.stringify({ type: 'book', symbol: bookSymbol }));
    };
    ws.onmessage = (e) => {
      let m; try { m = JSON.parse(e.data); } catch { return; }
      const h = handlers[m.type];
      if (h) h(m);
    };
    ws.onclose = () => {
      handlers.status && handlers.status(false);
      if (!closed) setTimeout(open, Math.min(8000, 500 * 2 ** retry++));
    };
  };
  open();
  return {
    setBookSymbol(s) { bookSymbol = s; if (ws && ws.readyState === 1) ws.send(JSON.stringify({ type: 'book', symbol: s })); },
    reauth() { if (ws && ws.readyState === 1 && token) ws.send(JSON.stringify({ type: 'auth', token })); },
    close() { closed = true; if (ws) ws.close(); },
  };
}
